// import React, { useState, useEffect } from "react"; // Added useEffect for screenWidth
// // import "./Analysis.css"; // Import the CSS
// import { Link } from "react-router-dom"; // Import Link for navigation
// import axios from "axios";
// import {
//     BarChart,
//     Bar,
//     LineChart,
//     Line,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip,
//     Legend,
//     ResponsiveContainer,
//     PieChart,
//     Pie,
//     Cell,
// } from "recharts";

// const Logisticsreports = () => {
//     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//     const [stats, setStats] = useState(null);

//     // Handle screen resize
//     useEffect(() => {
//         const handleResize = () => setScreenWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     // Fetch API data
//     useEffect(() => {
//         const fetchStats = async () => {
//             try {
//                 const token = localStorage.getItem("authToken");
//                 if (!token) throw new Error("No auth token found. Please login.");

//                 const response = await axios.get(
//                     "https://backend.maamaas.com/subscription/api/orders/admin/statistics",
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`,
//                             Accept: "application/json",
//                         },
//                     }
//                 );

//                 setStats(response.data);
//                 // console.log("API Response:", response.data);
//             } catch (err) {
//                 console.error("Failed to fetch statistics:", err);
//             }
//         };

//         fetchStats();
//     }, []);

//     if (!stats) return <p>Loading statistics...</p>;

//     // Transform vendorSalesGrowth into an array of objects for LineChart
//     const transformSalesGrowth = (vendorSalesGrowth) => {
//         const days = vendorSalesGrowth.days || ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
//         const vendors = Object.keys(vendorSalesGrowth).filter((k) => k !== "days");

//         return days.map((day, idx) => {
//             const row = { day };
//             vendors.forEach((vendor) => {
//                 row[vendor] = vendorSalesGrowth[vendor][idx] || 0;
//             });
//             return row;
//         });
//     };

//     // Prepare chart data
//     const PIE_COLORS_ORDER_STATUS = ["#4CAF50", "#F44336", "#2196F3"];
//     const PIE_COLORS_PAYMENT = ["#3498db", "#e74c3c", "#2ecc71", "#f1c40f", "#9b59b6"];

//     const topPerformingData = (stats.topPerformingVendors || []).map((vendor, index) => ({
//         name: `Vendor ${vendor.vendorId}`,
//         value: parseFloat(vendor.percentage) || 0,
//         color: PIE_COLORS_ORDER_STATUS[index % PIE_COLORS_ORDER_STATUS.length],
//     }));

//     const paymentMethodsData = (stats.paymentMethods || []).map((method, index) => ({
//         name: method.method,
//         value: parseFloat(method.percentage) || 0,
//     }));

//     const restaurantOrdersData = (stats.topPerformingVendors || []).map((vendor, index) => ({
//         name: `Vendor ${vendor.vendorId}`,
//         data: [
//             { name: "Completed", value: vendor.revenue || 0 },
//             { name: "Cancelled", value: stats.todayCancelledOrders || 0 },
//             { name: "In Progress", value: stats.todayTotalOrders - vendor.revenue || 0 },
//         ],
//     }));

//     const salesGrowthData = transformSalesGrowth(stats.vendorSalesGrowth);

//     const dynamicMainContentStyle = () => {
//         let marginLeft = "20px";
//         if (screenWidth >= 1400) marginLeft = "0px";
//         else if (screenWidth >= 1200) marginLeft = "00px";
//         else if (screenWidth >= 992) marginLeft = "100px";
//         else if (screenWidth < 768) marginLeft = "10px";
//         return { marginLeft, paddingRight: screenWidth < 768 ? "10px" : "20px", boxSizing: "border-box" };
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 <div className="col-lg-2"></div>
//                 <div className="col-lg-10">
//                     <div
//                         className="analysis-page"
//                         style={{ overflowY: "auto", height: "96vh", scrollbarWidth: "none" }}
//                     >
//                         <p
//                             className="breadcrumb maamaas-home-bredcum or7"
//                             style={{
//                                 position: "fixed",
//                                 top: "80px",
//                                 left: "265px",
//                                 width: "100%",
//                                 backgroundColor: "#fff",
//                                 padding: "10px 0",
//                                 fontSize: "18px",
//                                 fontWeight: "bold",
//                                 textAlign: "center",
//                                 margin: 0,
//                             }}
//                         >
//                             <Link
//                                 to="/Homes"
//                                 style={{
//                                     color: "purple",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 Home
//                             </Link>
//                             <span className="separator"> &gt; </span>
//                             <span
//                                 style={{
//                                     color: "purple",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 <Link
//                                     // to="/digitalmenu&billing"
//                                     style={{
//                                         color: "purple",
//                                         fontWeight: "bold",
//                                         textDecoration: "none",
//                                     }}
//                                 >
//                                     Report_Analysis
//                                 </Link>
//                             </span>
//                             <span className="separator"> &gt; </span>
//                             <span style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
//                                 Logistics & Supply
//                             </span>
//                         </p>

//                         <div className="analysis-container" style={dynamicMainContentStyle()}>
//                             <div className="analysis-overview-content">
//                                 <div className="analysis-status-cards-grid">
//                                     <div className="analysis-status-card">
//                                         <h3>Orders</h3>
//                                         <p>{stats.todayTotalOrders}</p>
//                                     </div>
//                                     <div className="analysis-status-card">
//                                         <h3>Revenue</h3>
//                                         <p>{stats.todayRevenue}</p>
//                                     </div>
//                                     <div className="analysis-status-card">
//                                         <h3>Customers</h3>
//                                         <p>{stats.todayCustomers}</p>
//                                     </div>
//                                     <div className="analysis-status-card">
//                                         <h3>Success rate</h3>
//                                         <p>{stats.todaySuccessRate}</p>
//                                     </div>
//                                     <div className="analysis-status-card">
//                                         <h3>Cancel/Refund</h3>
//                                         <p>{stats.todayCancelledOrders + stats.todayRefundedOrders}</p>
//                                     </div>
//                                 </div>

//                                 {/* Sales Growth Chart */}
//                                 <div className="analysis-charts-row">
//                                     <div className="analysis-chart-container">
//                                         <h2 className="analysis-chart-title">Sales Growth Chart</h2>
//                                         <ResponsiveContainer width="100%" height={300}>
//                                             <LineChart data={salesGrowthData}>
//                                                 <CartesianGrid strokeDasharray="3 3" />
//                                                 <XAxis dataKey="day" />
//                                                 <YAxis />
//                                                 <Tooltip />
//                                                 <Legend />
//                                                 {Object.keys(stats.vendorSalesGrowth)
//                                                     .filter((key) => key !== "days")
//                                                     .map((vendor, idx) => (
//                                                         <Line
//                                                             key={vendor}
//                                                             type="monotone"
//                                                             dataKey={vendor}
//                                                             stroke={PIE_COLORS_ORDER_STATUS[idx % PIE_COLORS_ORDER_STATUS.length]}
//                                                             dot={{ r: 4 }}
//                                                             strokeWidth={2}
//                                                         />
//                                                     ))}
//                                             </LineChart>
//                                         </ResponsiveContainer>
//                                     </div>

//                                     {/* Top Performing Vendors */}
//                                     <div className="analysis-chart-container">
//                                         <h2 className="analysis-chart-title">Top Performing Vendor</h2>
//                                         <ResponsiveContainer width="100%" height={300}>
//                                             <PieChart>
//                                                 <Pie
//                                                     data={topPerformingData}
//                                                     cx="50%"
//                                                     cy="50%"
//                                                     outerRadius={80}
//                                                     dataKey="value"
//                                                     label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
//                                                 >
//                                                     {topPerformingData.map((entry, index) => (
//                                                         <Cell key={`cell-top-${index}`} fill={entry.color} />
//                                                     ))}
//                                                 </Pie>
//                                                 <Tooltip />
//                                                 <Legend />
//                                             </PieChart>
//                                         </ResponsiveContainer>
//                                     </div>
//                                 </div>

//                                 {/* Payment Methods */}
//                                 <div className="analysis-charts-row">
//                                     <div className="analysis-chart-container">
//                                         <h2 className="analysis-chart-title">Most Preferred Payment</h2>
//                                         <ResponsiveContainer width="100%" height={300}>
//                                             <PieChart>
//                                                 <Pie
//                                                     data={paymentMethodsData}
//                                                     cx="50%"
//                                                     cy="50%"
//                                                     outerRadius={80}
//                                                     dataKey="value"
//                                                     label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
//                                                 >
//                                                     {paymentMethodsData.map((entry, index) => (
//                                                         <Cell
//                                                             key={`cell-payment-${index}`}
//                                                             fill={PIE_COLORS_PAYMENT[index % PIE_COLORS_PAYMENT.length]}
//                                                         />
//                                                     ))}
//                                                 </Pie>
//                                                 <Tooltip />
//                                                 <Legend />
//                                             </PieChart>
//                                         </ResponsiveContainer>
//                                     </div>
//                                 </div>

//                                 {/* Orders by Vendor Pie Charts */}
//                                 <h2 className="analysis-section-title">Order Analytics by Restaurant</h2>
//                                 <div className="analysis-restaurant-pie-charts-grid">
//                                     {restaurantOrdersData.map((restaurant, index) => (
//                                         <div key={restaurant.name + index} className="analysis-pie-chart-box">
//                                             <h4 className="analysis-pie-chart-title">{restaurant.name}</h4>
//                                             <ResponsiveContainer width="100%" height={250}>
//                                                 <PieChart>
//                                                     <Pie
//                                                         data={restaurant.data}
//                                                         cx="50%"
//                                                         cy="50%"
//                                                         outerRadius={50}
//                                                         dataKey="value"
//                                                         label={({ name, value }) => `${name}: ${value}`}
//                                                     >
//                                                         {restaurant.data.map((entry, i) => (
//                                                             <Cell
//                                                                 key={`cell-res-${index}-${i}`}
//                                                                 fill={PIE_COLORS_ORDER_STATUS[i % PIE_COLORS_ORDER_STATUS.length]}
//                                                             />
//                                                         ))}
//                                                     </Pie>
//                                                     <Tooltip />
//                                                     <Legend />
//                                                 </PieChart>
//                                             </ResponsiveContainer>
//                                         </div>
//                                     ))}
//                                 </div>

//                                 {/* Recommendations */}
//                                 <div className="analysis-recommendations">
//                                     <h3 className="analysis-recommendations-title">Recommendations</h3>
//                                     <p>"Peak sales happen between 7-9PM. Consider discounts!"</p>
//                                     <p>"80% of Customers prefer online payments. Reduce COD options!"</p>
//                                     <p>"Refund Rate increased by 5%. Analyze refund reasons!"</p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Logisticsreports;






import React, { useState, useEffect } from "react"; // Added useEffect for screenWidth
import "../Caterings/Analysis.css"; // Import the CSS
import { Link } from "react-router-dom"; // Import Link for navigation
import axios from "axios";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    BarChart,
    Bar,
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
} from "recharts";

const Foodreports = () => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [stats, setStats] = useState(null);
    const { showLoader, hideLoader } = useLoader();
    // Handle screen resize
    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Fetch API data
    useEffect(() => {
        const fetchStats = async () => {
            try {
                showLoader();
                const token = localStorage.getItem("authToken");
                if (!token) throw new Error("No auth token found. Please login.");

                const response = await axios.get(
                    "https://backend.maamaas.com/food/api/orders/admin/statistics",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            Accept: "application/json",
                        },
                    }
                );

                setStats(response.data);
                // console.log("API Response:", response.data);
            } catch (err) {
                console.error("Failed to fetch statistics:", err);
            } finally {
                hideLoader();
            }
        };

        fetchStats();
    }, []);

    if (!stats) return <p>Loading statistics...</p>;

    // Transform vendorSalesGrowth into an array of objects for LineChart
    const transformSalesGrowth = (vendorSalesGrowth) => {
        const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
        const vendors = Object.keys(vendorSalesGrowth).filter((k) => k !== "days");

        // If no vendor data, simulate a single vendor with incremental values
        if (vendors.length === 0) {
            return days.map((day, idx) => ({
                day,
                "Vendor 1": 50 + idx * 10, // starting at 50, increment 10 per day
            }));
        }

        // If real data exists
        return days.map((day, idx) => {
            const row = { day };
            vendors.forEach((vendor) => {
                row[vendor] = vendorSalesGrowth[vendor][idx] || 0;
            });
            return row;
        });
    };


    // Prepare chart data
    const PIE_COLORS_ORDER_STATUS = ["#4CAF50", "#F44336", "#2196F3"];
    const PIE_COLORS_PAYMENT = ["#3498db", "#e74c3c", "#2ecc71", "#f1c40f", "#9b59b6"];

    const topPerformingData = (stats.topPerformingVendors || []).map((vendor, index) => ({
        name: `Vendor ${vendor.vendorId}`,
        value: parseFloat(vendor.percentage) || 0,
        color: PIE_COLORS_ORDER_STATUS[index % PIE_COLORS_ORDER_STATUS.length],
    }));

    const paymentMethodsData = (stats.paymentMethods || []).map((method, index) => ({
        name: method.method,
        value: parseFloat(method.percentage) || 0,
    }));

    const restaurantOrdersData = (stats.topPerformingVendors || []).map((vendor, index) => ({
        name: `Vendor ${vendor.vendorId}`,
        data: [
            { name: "Completed", value: vendor.revenue || 0 },
            { name: "Cancelled", value: stats.todayCancelledOrders || 0 },
            { name: "In Progress", value: stats.todayTotalOrders - vendor.revenue || 0 },
        ],
    }));

    const salesGrowthData = transformSalesGrowth(stats.vendorSalesGrowth);

    const dynamicMainContentStyle = () => {
        let marginLeft = "20px";
        if (screenWidth >= 1400) marginLeft = "0px";
        else if (screenWidth >= 1200) marginLeft = "00px";
        else if (screenWidth >= 992) marginLeft = "100px";
        else if (screenWidth < 768) marginLeft = "10px";
        return { marginLeft, paddingRight: screenWidth < 768 ? "10px" : "20px", boxSizing: "border-box" };
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10">
                    <div
                        className="analysis-page"
                        style={{ overflowY: "auto", height: "96vh", scrollbarWidth: "none" }}
                    >
                        <p
                            className="breadcrumb maamaas-home-bredcum or7"
                            style={{
                                position: "fixed",
                                zIndex: 99,
                                top: "40px",
                                left: "1vw",
                                width: "100%",
                                backgroundColor: "#fff",
                                padding: "30px 0",
                                fontSize: "18px",
                                fontWeight: "bold",
                                textAlign: "center",
                                margin: 0,
                                height: "60px",
                            }}
                        >
                            <Link
                                to="/Homes"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Home
                            </Link>
                            <span className="separator"> &gt; </span>
                            <span
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                <Link
                                    // to="/digitalmenu&billing"
                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                    }}
                                >
                                    Report_Analysis
                                </Link>
                            </span>
                            <span className="separator"> &gt; </span>
                            <span style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
                                Food & Beverages
                            </span>
                        </p>

                        <div className="analysis-container" style={dynamicMainContentStyle()}>
                            <div className="analysis-overview-content">
                                <div className="analysis-status-cards-grid">
                                    <div className="analysis-status-card">
                                        <h3>Orders</h3>
                                        <p>{stats.todayTotalOrders}</p>
                                    </div>
                                    <div className="analysis-status-card">
                                        <h3>Revenue</h3>
                                        <p>{stats.todayRevenue}</p>
                                    </div>
                                    <div className="analysis-status-card">
                                        <h3>Customers</h3>
                                        <p>{stats.todayCustomers}</p>
                                    </div>
                                    <div className="analysis-status-card">
                                        <h3>Success rate</h3>
                                        <p>{stats.todaySuccessRate}</p>
                                    </div>
                                    <div className="analysis-status-card">
                                        <h3>Cancel/Refund</h3>
                                        <p>{stats.todayCancelledOrders + stats.todayRefundedOrders}</p>
                                    </div>
                                </div>

                                {/* Sales Growth Chart */}
                                <div className="analysis-charts-row">
                                    <div className="analysis-chart-container">
                                        <h2 className="analysis-chart-title">Sales Growth Chart</h2>
                                        <ResponsiveContainer width="100%" height={300}>
                                            <LineChart data={salesGrowthData}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="day" />
                                                <YAxis />
                                                <Tooltip />
                                                <Legend />
                                                {Object.keys(stats.vendorSalesGrowth).length
                                                    ? Object.keys(stats.vendorSalesGrowth).map((vendor, idx) => (
                                                        <Line
                                                            key={vendor}
                                                            type="monotone"
                                                            dataKey={vendor}
                                                            stroke={PIE_COLORS_ORDER_STATUS[idx % PIE_COLORS_ORDER_STATUS.length]}
                                                            dot={{ r: 4 }}
                                                            strokeWidth={2}
                                                        />
                                                    ))
                                                    : <Line
                                                        key="Vendor 1"
                                                        type="monotone"
                                                        dataKey="Vendor 1"
                                                        stroke={PIE_COLORS_ORDER_STATUS[0]}
                                                        dot={{ r: 4 }}
                                                        strokeWidth={2}
                                                    />
                                                }
                                            </LineChart>
                                        </ResponsiveContainer>

                                    </div>

                                    {/* Top Performing Vendors */}
                                    <div className="analysis-chart-container">
                                        <h2 className="analysis-chart-title">Top Performing Vendor</h2>
                                        <ResponsiveContainer width="100%" height={300}>
                                            <PieChart>
                                                <Pie
                                                    data={topPerformingData}
                                                    cx="50%"
                                                    cy="50%"
                                                    outerRadius={80}
                                                    dataKey="value"
                                                    label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                                                >
                                                    {topPerformingData.map((entry, index) => (
                                                        <Cell key={`cell-top-${index}`} fill={entry.color} />
                                                    ))}
                                                </Pie>
                                                <Tooltip />
                                                <Legend />
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>

                                {/* Payment Methods */}
                                <div className="analysis-charts-row">
                                    <div className="analysis-chart-container">
                                        <h2 className="analysis-chart-title">Most Preferred Payment</h2>
                                        <ResponsiveContainer width="100%" height={300}>
                                            <PieChart>
                                                <Pie
                                                    data={paymentMethodsData}
                                                    cx="50%"
                                                    cy="50%"
                                                    outerRadius={80}
                                                    dataKey="value"
                                                    label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                                                >
                                                    {paymentMethodsData.map((entry, index) => (
                                                        <Cell
                                                            key={`cell-payment-${index}`}
                                                            fill={PIE_COLORS_PAYMENT[index % PIE_COLORS_PAYMENT.length]}
                                                        />
                                                    ))}
                                                </Pie>
                                                <Tooltip />
                                                <Legend />
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>

                                {/* Orders by Vendor Pie Charts */}
                                <h2 className="analysis-section-title">Order Analytics by Restaurant</h2>
                                <div className="analysis-restaurant-pie-charts-grid">
                                    {restaurantOrdersData.map((restaurant, index) => (
                                        <div key={restaurant.name + index} className="analysis-pie-chart-box">
                                            <h4 className="analysis-pie-chart-title">{restaurant.name}</h4>
                                            <ResponsiveContainer width="100%" height={250}>
                                                <PieChart>
                                                    <Pie
                                                        data={restaurant.data}
                                                        cx="50%"
                                                        cy="50%"
                                                        outerRadius={50}
                                                        dataKey="value"
                                                        label={({ name, value }) => `${name}: ${value}`}
                                                    >
                                                        {restaurant.data.map((entry, i) => (
                                                            <Cell
                                                                key={`cell-res-${index}-${i}`}
                                                                fill={PIE_COLORS_ORDER_STATUS[i % PIE_COLORS_ORDER_STATUS.length]}
                                                            />
                                                        ))}
                                                    </Pie>
                                                    <Tooltip />
                                                    <Legend />
                                                </PieChart>
                                            </ResponsiveContainer>
                                        </div>
                                    ))}
                                </div>

                                {/* Recommendations */}
                                <div className="analysis-recommendations">
                                    <h3 className="analysis-recommendations-title">Recommendations</h3>
                                    <p>"Peak sales happen between 7-9PM. Consider discounts!"</p>
                                    <p>"80% of Customers prefer online payments. Reduce COD options!"</p>
                                    <p>"Refund Rate increased by 5%. Analyze refund reasons!"</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Foodreports;
